import { Banner, BannerPlatform, ParamsBannerForForm } from 'types/banner';
import { Colors } from 'types/colors';
import { ImageFields, ImagePreset, Images } from 'types/photo';

export type CreateBannerFormValuesProps = ParamsBannerForForm;
export type EditBannerFormValuesProps = Banner;

export enum BANNER_TAB_VALUES {
  INFO = 'info',
  STYLING = 'styling',
}

export const BANNER_PLATFORM_OPTIONS = [
  { value: BannerPlatform.ANDROID, label: 'Android' },
  { value: BannerPlatform.HUAWEI, label: 'Huawei' },
  { value: BannerPlatform.IOS, label: 'iOS' },
  { value: BannerPlatform.WEB_DESKTOP, label: 'Web desktop' },
  { value: BannerPlatform.WEB_MOBILE, label: 'Web mobile' },
];

export const BANNER_IMAGES_PRESETS: Record<keyof Images, ImagePreset> = {
  [ImageFields.MOBILE]: {
    width: 750,
    height: 1080,
    title: 'Мобильная версия',
  },
  [ImageFields.DESKTOP]: {
    width: 2400,
    height: 880,
    title: 'ПК версия',
  },
};

export const COLOR: Colors[] = [Colors.white, Colors.black, Colors.lime];
